{
  "nameInput": {
    "placeholder": "نام شما چیست؟"
  },
  "signIn": {
    "tagline": "با نیت آغاز کن.",
    "signingIn": "در حال ورود…",
    "continueApple": "ادامه با Apple",
    "continueApple_aria": "ادامه با Apple",
    "continueGoogle": "ادامه با Google",
    "continueGoogle_aria": "ادامه با Google",
    "logo_alt": "Rhemn",
    "footer": "با ورود، شما با شرایط خدمات و <privacyLink>سیاست حریم خصوصی</privacyLink> ما موافقت می‌کنید.",
    "divider": "یا"
  },
  "email": {
    "identity": {
      "label": "نشانی ایمیل",
      "placeholder": "you@example.com",
      "change": "تغییر",
      "change_aria": "تغییر نشانی ایمیل"
    },
    "password": {
      "label": "گذرواژه",
      "labelNew": "یک گذرواژه انتخاب کنید",
      "placeholder": "گذرواژه",
      "placeholderNew": "یک گذرواژه بسازید",
      "show": "نمایش گذرواژه",
      "hide": "پنهان کردن گذرواژه"
    },
    "actions": {
      "continue": "ادامه",
      "signIn": "ورود",
      "createAccount": "ساخت حساب",
      "forgot": "گذرواژه را فراموش کرده‌اید؟",
      "backToSignIn": "بازگشت به ورود",
      "iVerified": "ایمیلم را تأیید کردم",
      "resend": "ارسال دوباره پیوند",
      "resendIn": "ارسال دوباره تا {{time}}",
      "signInInstead": "ورود"
    },
    "busy": {
      "checking": "در حال بررسی…",
      "signingIn": "در حال ورود…",
      "creating": "در حال ساخت حساب شما…",
      "sending": "در حال ارسال…"
    },
    "switch": {
      "toCreate": "در Rhemn تازه‌وارد هستید؟ <switchBtn>یک حساب بسازید</switchBtn>",
      "toSignIn": "از قبل حساب دارید؟ <switchBtn>وارد شوید</switchBtn>"
    },
    "strength": {
      "tooShort": "دست‌کم ۱۲ نویسه.",
      "level1": "خوب است. هرچه بلندتر، امن‌تر.",
      "level2": "گذرواژهٔ قوی.",
      "level3": "گذرواژهٔ بسیار قوی."
    },
    "sent": {
      "title": "صندوق ورودی خود را ببینید",
      "body": "پیوند بازنشانی را به {{email}} فرستادیم. اعتبار آن یک ساعت است.",
      "resent": "دوباره فرستاده شد. صندوق ورودی خود را ببینید."
    },
    "verify": {
      "title": "ایمیل خود را تأیید کنید",
      "body": "پیوندی به {{email}} فرستادیم. برای تکمیل راه‌اندازی حسابتان آن را باز کنید — از آنجا به‌صورت خودکار ادامه می‌دهیم.",
      "waiting": "در انتظار باز کردن پیوند از سوی شما…",
      "resent": "دوباره فرستاده شد. صندوق ورودی خود را ببینید."
    },
    "errors": {
      "invalidEmail": "این شبیه نشانی ایمیل نیست.",
      "missingPassword": "گذرواژه خود را وارد کنید.",
      "invalidCredential": "ایمیل یا گذرواژه نادرست است.",
      "emailInUse": "این ایمیل از قبل حساب دارد. <signInBtn>وارد شوید.</signInBtn>",
      "weakPassword": "دست‌کم ۱۲ نویسه استفاده کنید.",
      "passwordTooShort": "دست‌کم ۱۲ نویسه استفاده کنید.",
      "passwordCommon": "حدس زدن این گذرواژه بسیار آسان است. چیزی کمتر قابل پیش‌بینی امتحان کنید.",
      "emailNotVerified": "پیش از ادامه، ایمیل خود را تأیید کنید.",
      "providerGoogle": "این ایمیل از قبل با Google تنظیم شده است. در پایین با Google ادامه دهید.",
      "providerApple": "این ایمیل از قبل با Apple تنظیم شده است. در پایین با Apple ادامه دهید.",
      "userDisabled": "این حساب غیرفعال شده است.",
      "requiresRecentLogin": "برای انجام این تغییر دوباره وارد شوید.",
      "sessionExpired": "نشست شما به پایان رسید. دوباره وارد شوید.",
      "expiredActionCode": "اعتبار این پیوند تمام شده است. پیوند تازه‌ای بخواهید.",
      "invalidActionCode": "این پیوند دیگر معتبر نیست. پیوند تازه‌ای بخواهید.",
      "tooManyRequests": "تلاش‌های بسیار زیاد. چند دقیقه صبر کنید یا گذرواژه را بازنشانی کنید.",
      "network": "اتصالی نیست. شبکه خود را بررسی و دوباره تلاش کنید.",
      "operationNotAllowed": "ورود با ایمیل در حال حاضر در دسترس نیست.",
      "generic": "مشکلی پیش آمد. لطفاً دوباره تلاش کنید."
    },
    "a11y": {
      "stepEmail": "گام ۱ از ۲. نشانی ایمیل خود را وارد کنید.",
      "stepPasswordSignIn": "گام ۲ از ۲. برای ورود گذرواژه خود را وارد کنید.",
      "stepPasswordCreate": "گام ۲ از ۲. برای حساب تازه‌تان یک گذرواژه انتخاب کنید.",
      "stepSent": "پیوند بازنشانی فرستاده شد. صندوق ورودی خود را ببینید.",
      "stepVerify": "حساب ساخته شد. پیوند تأیید فرستاده شد.",
      "resendReady": "اکنون می‌توانید پیوند را دوباره بفرستید."
    }
  }
}
